export default "__VITE_PUBLIC_ASSET__86aa7507__"